import React, { useEffect, useMemo, useRef } from 'react';
import Select, { Creatable } from 'react-select';
import { components } from 'react-select/lib/components';
import { AutocompleteControlComponent } from './Autocomplete';
var topStyle = {
  transform: 'translateY(calc(-100% - 2rem))'
};
var PORTAL_OFFSET = 50;
var DROPDOWN_OFFSET = 150;
export var autoPortalPlacement = function autoPortalPlacement(height, portalRef) {
  if (portalRef !== undefined && portalRef.bottom + PORTAL_OFFSET > height + PORTAL_OFFSET - DROPDOWN_OFFSET) {
    defaultStyles.menuPortal = function (provided) {
      return Object.assign({}, provided, topStyle, {
        width: 'auto',
        zIndex: 9999
      });
    };
  } else if (portalRef !== undefined && portalRef.top - portalRef.height - PORTAL_OFFSET > PORTAL_OFFSET + DROPDOWN_OFFSET) {
    defaultStyles.menuPortal = function (provided) {
      return Object.assign({}, provided, {
        width: 'auto',
        zIndex: 9999
      });
    };
  } else {
    defaultStyles.menuPortal = function (provided) {
      return Object.assign({}, provided, {
        width: 'auto',
        zIndex: 9999
      });
    };
  }
};
export var SelectMenuPortal = function SelectMenuPortal(props) {
  var element = document.getElementById('dashboard-content');

  if (element) {
    element.className += ' disableScroll';
  }

  var ref = useRef(null);
  useEffect(function () {
    var portalRef = (ref && ref.current && ref.current.props.controlElement).getBoundingClientRect();
    var windowHeight = window.innerHeight;
    autoPortalPlacement(windowHeight, portalRef ? portalRef : undefined);
    return function () {
      var element = document.getElementById('dashboard-content');

      if (element) {
        element.className = element.className.slice(0, element.className.indexOf('disableScroll'));
      }

      autoPortalPlacement(windowHeight, portalRef ? portalRef : undefined);
    };
  }, [ref]);
  return React.createElement(components.MenuPortal, Object.assign({}, props, {
    ref: ref
  }));
};
export var defaultStyles = {
  menuPortal: function menuPortal(provided) {
    return Object.assign({}, provided, {
      width: 'auto',
      zIndex: 9999
    });
  },
  singleValue: function singleValue(provided) {
    return Object.assign({}, provided, {
      color: 'var(--blue) !important'
    });
  }
};

var useSelectProps = function useSelectProps(props) {
  var styles = useMemo(function () {
    return defaultStyles;
  }, [props]);
  return useMemo(function () {
    return Object.assign({
      styles: styles,
      classNamePrefix: 'select',
      id: 'scrollable',
      className: "".concat(props.className || '', " basic-multi-select"),
      menuPortalTarget: document.getElementById('portal-root'),
      components: Object.assign({
        DropdownIndicator: null,
        Control: AutocompleteControlComponent,
        MenuPortal: SelectMenuPortal
      }, props.components || {})
    }, props);
  }, [props, styles]);
};

export var BasicSelect = function BasicSelect(props) {
  var selectProps = useSelectProps(props);
  return React.createElement(Select, Object.assign({}, selectProps));
};
export var BasicCreatableSelect = function BasicCreatableSelect(props) {
  return React.createElement(Creatable, Object.assign({}, {
    classNamePrefix: 'select',
    menuPortalTarget: document.getElementById('portal-root'),
    styles: defaultStyles,
    className: "basic-multi-select"
  }, props));
};